import { SharedMethodsService } from 'src/app/services/shared-methods.service';
import { ValidationService } from '../../services/validation.service';
import { ManagementArea } from '../area-models/management-area.model';
import { Subarea } from '../area-models/subarea.model';
import { SpeciesData } from '../catch-table-models/species-data.model';
import { Net } from '../user-models/net.model';
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz-', 21);

export class DailyCatchReport {

  internalId: string = '';

  netUsed: Net = new Net(); // unique to Gill Net

  licenseNumber: string = '';

  dateFished: Date = new Date();

  effortStart: Date = new Date();

  effortEnd: Date = new Date();

  hoursFished: string = '';

  managementArea: ManagementArea = new ManagementArea();

  subAreas: Subarea[] = [];

  numSets: string = ''; // unique to Gill Net & Seine

  storageType: string = ''; // unique to Troll

  numGrilse!: number; // unique to Troll

  soakedDuration: number = 0;

  speciesDataList: SpeciesData[] = []; // catch data

  sarIndicator!: boolean;

  lostGearIndicator!: boolean;

  marineMammalIndicator!: boolean;

  effortComments: string = '';

  effortDetailComments: string = '';

  effortGearRemarks: string = '';

  otherSpecies: string = '';

  comments: string = ''; // optional

  reportID: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // date the report was completed within the app

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  /* Flags for programmatical use */

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  lastUpdate: Date = new Date();

  isComplete: boolean = false; // flag that tells us if the report has been completed

  constructor() {
    this.internalId = 'id-' + nanoid();
    this.reportID = SharedMethodsService.generateReportID("D");
  }

  public toString(): string {
    return 'Date: ' + this.dateFished + '; Daily Catch Report Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's Daily Catch Reports are defined
  public static transformAnonymous(dailyCatchReports: any): DailyCatchReport[] {

    // if it is not defined, set a new one
    if (!dailyCatchReports) {
      return [];
    }

    let userDailyCatchReports: DailyCatchReport[] = [];
    for (let dailyCatchReport of dailyCatchReports) {
      let userDailyCatchReport: DailyCatchReport = new DailyCatchReport();
      userDailyCatchReport.internalId = dailyCatchReport.internalId ?? 'id-' + nanoid();
      userDailyCatchReport.licenseNumber = dailyCatchReport.licenseNumber ?? '';
      userDailyCatchReport.marineMammalIndicator = dailyCatchReport.marineMammalIndicator ?? false;
      userDailyCatchReport.lostGearIndicator = dailyCatchReport.lostGearIndicator ?? false;
      userDailyCatchReport.sarIndicator = dailyCatchReport.sarIndicator ?? false;
      userDailyCatchReport.netUsed = Net.transformAnonymous(dailyCatchReport.netUsed);
      userDailyCatchReport.dateFished = ValidationService.validateDate(dailyCatchReport.dateFished);
      userDailyCatchReport.effortStart = ValidationService.validateDate(dailyCatchReport.effortStart);
      userDailyCatchReport.effortEnd = ValidationService.validateDate(dailyCatchReport.effortEnd);
      userDailyCatchReport.hoursFished = dailyCatchReport.hoursFished ?? '';
      userDailyCatchReport.managementArea = ManagementArea.transformAnonymous(dailyCatchReport.managementArea);
      userDailyCatchReport.subAreas = Subarea.transformAnonArray(dailyCatchReport.subAreas);
      userDailyCatchReport.numSets = dailyCatchReport.numSets ?? '';
      userDailyCatchReport.soakedDuration = dailyCatchReport.soakedDuration ?? 0;
      userDailyCatchReport.storageType = dailyCatchReport.storageType ?? '';
      userDailyCatchReport.numGrilse = dailyCatchReport.numGrilse ?? 0;
      userDailyCatchReport.speciesDataList = SpeciesData.transformAnonArray(dailyCatchReport.speciesDataList);
      userDailyCatchReport.comments = dailyCatchReport.comments ?? '';
      userDailyCatchReport.effortComments = dailyCatchReport.effortComments ?? '';
      userDailyCatchReport.effortDetailComments = dailyCatchReport.effortDetailComments ?? '';
      userDailyCatchReport.effortGearRemarks = dailyCatchReport.effortGearRemarks ?? '';
      userDailyCatchReport.reportID = dailyCatchReport.reportID;
      userDailyCatchReport.confirmationNumber = dailyCatchReport.confirmationNumber ?? '';
      userDailyCatchReport.emailedAt = dailyCatchReport.emailedAt ?? '';
      userDailyCatchReport.completionDate = ValidationService.validateDate(dailyCatchReport.completionDate);
      userDailyCatchReport.submissionDate = ValidationService.validateDate(dailyCatchReport.submissionDate);
      userDailyCatchReport.isSubmitted = dailyCatchReport.isSubmitted ?? false;
      userDailyCatchReport.isComplete = dailyCatchReport.isComplete ?? false;
      userDailyCatchReport.lastUpdate = userDailyCatchReport.lastUpdate ?? new Date();
      userDailyCatchReports.push(userDailyCatchReport);
    }
    return userDailyCatchReports;

  }
}
